export const INFLUENCER_COUPON_KEY = 'influencerCouponCode';

export function normalizeCouponCode(code) {
  return String(code || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
}

export function storeInfluencerCoupon(code) {
  const normalized = normalizeCouponCode(code);
  if (!normalized) return;
  try {
    localStorage.setItem(INFLUENCER_COUPON_KEY, normalized);
  } catch (_) {}
}

export function getStoredInfluencerCoupon() {
  try {
    return localStorage.getItem(INFLUENCER_COUPON_KEY) || '';
  } catch {
    return '';
  }
}

export function clearStoredInfluencerCoupon() {
  try {
    localStorage.removeItem(INFLUENCER_COUPON_KEY);
  } catch (_) {}
}

/** Read ?coupon=, ?ref=, or ?promo= from current URL and persist. */
export function captureInfluencerCouponFromUrl() {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search || '');
  const code =
    params.get('coupon') || params.get('ref') || params.get('promo') || params.get('code');
  if (code) {
    storeInfluencerCoupon(code);
    return normalizeCouponCode(code);
  }
  return getStoredInfluencerCoupon() || null;
}

export function buildInfluencerShareUrl(promoCode) {
  const code = normalizeCouponCode(promoCode);
  if (!code || typeof window === 'undefined') return '';
  const origin = window.location.origin || '';
  return `${origin}/ref/${code}`;
}

export function buildInfluencerSignupUrl(promoCode) {
  const base = buildInfluencerShareUrl(promoCode);
  if (!base) return '';
  return `${base}?coupon=${normalizeCouponCode(promoCode)}`;
}
